import { useGetRequiredRule, useLengthValidationRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { AiBotConfigFormFields } from '../helpers/types';

const useAiBotConfigFormRules = () => {
  const { t } = useTranslation(['validation']);
  const requiredRule = useGetRequiredRule({ t });
  const senderNameLengthRule = useLengthValidationRule({ t, max: 64 });
  const welcomeMessageLengthRule = useLengthValidationRule({ t, max: 1000 });
  const disclaimerMessageLengthRule = useLengthValidationRule({ t, max: 500 });

  return {
    [AiBotConfigFormFields.SENDER_NAME]: [requiredRule, senderNameLengthRule],
    [AiBotConfigFormFields.MAIN_COLOR]: [requiredRule],
    [AiBotConfigFormFields.WELCOME_MESSAGE]: [requiredRule, welcomeMessageLengthRule],
    [AiBotConfigFormFields.DISCLAIMER_MESSAGE]: [requiredRule, disclaimerMessageLengthRule],
  };
};

export default useAiBotConfigFormRules;
